import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button, Stack, CircularProgress, Tooltip, IconButton, Chip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SyncIcon from '@mui/icons-material/Sync';
import { useNavigate } from 'react-router';
import { useGetMachineSubscription } from 'hooks/useMachineHooks';
import MachineSubscriptionViewModuleSkeleton from 'ui-component/cards/Skeleton/MachineSubscriptionViewModuleSkeleton';
import { gridSpacing } from 'store/constant';
import TimerIcon from '@mui/icons-material/Timer';
import { styled, keyframes } from '@mui/system';

const pulse = keyframes`
  0% {
    transform: scale(1);
    color: #1976d2;
  }
  50% {
    transform: scale(1.2);
    color:rgb(76, 204, 157);
  }
  100% {
    transform: scale(1);
    color: #1976d2;
  }
`;

const AnimatedTimer = styled(TimerIcon)`
  animation: ${pulse} 1.5s infinite;
  font-size: 24px;
  margin-top: -3px;
  margin-right: 2px;
`;

export default function MachineSubscription({ machineDetails, machineSubscriptionleftTimeText, open, setOpen, callFrom }) {
  const navigate = useNavigate();
  const [subscriptionPlan, setSubscriptionPlan] = useState({
    isSync: false,
    activeSubscription: machineDetails?.activeSubscription ?? {},
    isLoading: true
  });

  let syncData = { active: false, id: open.machineId };
  const {
    data: machineSyncSubscription,
    // isLoading: isLoadingMachineSyncSubscription,
    refetch: refetchMachineSyncSubscription,
    isRefetching: isRefetchingMachineSyncSubscription
  } = useGetMachineSubscription(syncData);

  const handelSyncSubscription = () => {
    syncData = { ...syncData, active: true };
    setSubscriptionPlan((prev) => ({ ...prev, isSync: true, isLoading: true }));
    refetchMachineSyncSubscription();
  };

  useEffect(() => {
    if (machineDetails?.activeSubscription && !subscriptionPlan?.isSync) {
      setTimeout(() => {
        setSubscriptionPlan((prev) => ({
          ...prev,
          isSync: false,
          activeSubscription: machineDetails?.activeSubscription || {},
          isLoading: false
        }));
      }, 1500);
    } else {
      setSubscriptionPlan((prev) => ({
        ...prev,
        isSync: false,
        activeSubscription: {},
        isLoading: false
      }));
    }
  }, [machineDetails]);

  useEffect(() => {
    if (subscriptionPlan?.isSync) {
      setTimeout(() => {
        setSubscriptionPlan((prev) => ({
          ...prev,
          isSync: true,
          activeSubscription: machineSyncSubscription?.activeSubscription || {},
          isLoading: false
        }));
      }, 1500);
    }
  }, [isRefetchingMachineSyncSubscription, machineSyncSubscription]);

  //   if (isLoading || subscriptionPlan.isLoading) return <MachineSubscriptionViewModuleSkeleton />;

  return (
    <>
      {subscriptionPlan.isLoading ? (
        <>
          <MachineSubscriptionViewModuleSkeleton />
        </>
      ) : (
        <>
          {subscriptionPlan?.activeSubscription?.plan ? (
            <>
              <Grid item xs={12} className="machineModalView">
                <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
                  {/* Container for header and Sync button */}
                  {/* <div style={{ position: 'relative' }}> */}
                  <div
                    className="address_locationmain"
                    style={{ background: '#6fd74b', marginBottom: 2, position: 'relative', padding: '10px 18px' }}
                  >
                    <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
                      Machine Subscription
                    </Typography>
                    {/* </div> */}

                    {/* Sync Button positioned at top-right */}
                    <Tooltip title="Sync Subscription">
                      <IconButton
                        onClick={() => handelSyncSubscription()}
                        // disabled={
                        //   values?.hasGlobalAccess ||
                        //   machineListIsLoading ||
                        //   isRefetchingAssignMachine ||
                        //   (isAdd ? false : transformedPermissionsAddEdit['empAllocateMachine']?.isStatic)
                        // }
                        style={{
                          position: 'absolute',
                          // top: '6.9px',
                          right: '15px',
                          backgroundColor: '#fff',
                          color: '#6fd74b',
                          padding: '1px'
                        }}
                        color="primary"
                      >
                        {isRefetchingMachineSyncSubscription ? <CircularProgress sx={{ padding: '3px' }} size={24} /> : <SyncIcon />}
                      </IconButton>
                    </Tooltip>
                  </div>
                  <Grid container spacing={gridSpacing} className="machineModalView" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ paddingTop: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Plan Name :{' '}
                          </Typography>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {subscriptionPlan?.activeSubscription?.plan?.name || 'N.A.'}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Plan Price :{' '}
                          </Typography>
                          <Typography variant="h4" component="sapn" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            ({subscriptionPlan?.activeSubscription?.plan?.regularBillingCycle?.price?.currencyCode})&nbsp;
                            {subscriptionPlan?.activeSubscription?.plan?.regularBillingCycle?.price?.value || ''} /{' '}
                            {subscriptionPlan?.activeSubscription?.plan?.regularBillingCycle?.intervalCount &&
                            subscriptionPlan?.activeSubscription?.plan?.regularBillingCycle?.intervalCount <= 1
                              ? ''
                              : subscriptionPlan?.activeSubscription?.plan?.regularBillingCycle?.intervalCount}
                            &nbsp;
                            {subscriptionPlan?.activeSubscription?.plan?.regularBillingCycle?.intervalUnit || ''}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Trial Period :{' '}
                          </Typography>
                          <Typography variant="h4" component="sapn" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.price?.value <= 0 ? (
                              <>
                                {subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalCount &&
                                subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalCount <= 0
                                  ? ''
                                  : subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalCount}
                                &nbsp;
                                {subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalUnit || ''} - FREE
                              </>
                            ) : (
                              <>
                                {subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalCount &&
                                subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalCount <= 0
                                  ? ''
                                  : subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalCount}
                                &nbsp;
                                {subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.intervalUnit || ''} - (
                                {subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.price?.currencyCode})&nbsp;
                                {subscriptionPlan?.activeSubscription?.plan?.trialPeriod?.price?.value || ''}
                              </>
                            )}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Global User Count :{' '}
                          </Typography>
                          <Typography variant="h4" component="sapn" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {subscriptionPlan?.activeSubscription?.plan?.globalUserCount || 'N.A.'}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Machine Specific User Count :{' '}
                          </Typography>
                          <Typography variant="h4" component="sapn" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {subscriptionPlan?.activeSubscription?.plan?.localUserCount || 'N.A.'}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Advertisement Count :{' '}
                          </Typography>
                          <Typography variant="h4" component="sapn" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {subscriptionPlan?.activeSubscription?.plan?.adCount || 'N.A.'}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Subscription Tax :{' '}
                          </Typography>
                          <Typography variant="h4" component="sapn" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                            {subscriptionPlan?.activeSubscription?.plan?.tax + '%' || 'N.A.'}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
                      <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                        <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                          <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                            Subscription Status :{' '}
                          </Typography>
                          <Typography variant="h4" component="sapn" style={{ fontWeight: 'normal', paddingTop: 10 }}>
                            {/* {machineDetails?.activeSubscription?.subscription?.status &&
                                    machineDetails?.activeSubscription?.subscription?.status === 'ACTIVE' ? (
                                      <span style={{ color: '#6fd74b' }}>ACTIVE</span>
                                    ) : (
                                      machineDetails?.activeSubscription?.subscription?.status || 'N.A.'
                                    )} */}
                            {subscriptionPlan?.activeSubscription?.subscription?.status && (
                              <Chip
                                // label={machineDetails?.activeSubscription?.subscription?.status}
                                label={
                                  subscriptionPlan?.activeSubscription?.subscription?.status === 'Pending'
                                    ? 'Pending'
                                    : subscriptionPlan?.activeSubscription?.subscription?.status === 'ACTIVE'
                                    ? 'ACTIVE'
                                    : subscriptionPlan?.activeSubscription?.subscription?.status === 'APPROVAL_PENDING'
                                    ? 'APPROVAL PENDING'
                                    : subscriptionPlan?.activeSubscription?.subscription?.status === 'WITHDRAWN'
                                    ? 'WITHDRAWN'
                                    : 'CANCELLED'
                                }
                                // color={subStatusColor}
                                sx={{
                                  // backgroundColor: subStatusColor,
                                  color: '#fff',
                                  backgroundColor:
                                    subscriptionPlan?.activeSubscription?.subscription?.status === 'Pending'
                                      ? '#ae30c2'
                                      : subscriptionPlan?.activeSubscription?.subscription?.status === 'ACTIVE'
                                      ? '#30c42b'
                                      : subscriptionPlan?.activeSubscription?.subscription?.status === 'APPROVAL_PENDING'
                                      ? '#bc7d14'
                                      : subscriptionPlan?.activeSubscription?.subscription?.status === 'WITHDRAWN'
                                      ? '#bc7d14'
                                      : '#d84315'
                                }}
                                size="small"
                              />
                            )}
                          </Typography>
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} className="subs_machine_view">
                      <div
                        style={{
                          border: '1px solid #6fd74b',
                          borderRadius: '6px',
                          marginLeft: 15,
                          marginRight: 15,
                          marginTop: '20px',
                          marginBottom: '10px',
                          minHeight: '200px'
                        }}
                      >
                        <div style={{ background: '#6fd74b', color: '#fff', padding: '10px', fontSize: '16px' }}>
                          Subscription Plan Description
                        </div>
                        <div style={{ padding: '10px' }}>
                          {/* <Typography variant="body2" component={'h6'} sx={{ margin: 0, fontWeight: 'bold' }}>
                                  Subscription Features :{' '}
                                </Typography> */}
                          <Typography variant="body2" sx={{ marginTop: '4px' }}>
                            {subscriptionPlan?.activeSubscription?.plan?.description || 'N.A.'}
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <div
                        className="subs_featre_bxnew"
                        style={{
                          border: '1px solid #6fd74b',
                          borderRadius: '6px',
                          marginLeft: 15,
                          marginRight: 15,
                          marginTop: '20px',
                          marginBottom: '10px',
                          minHeight: '200px'
                        }}
                      >
                        <div style={{ background: '#6fd74b', color: '#fff', padding: '10px', fontSize: '16px' }}>
                          Subscription Plan Features
                        </div>
                        <div style={{ padding: '10px' }}>
                          {/* <Typography variant="body2" component={'h6'} sx={{ margin: 0, fontWeight: 'bold' }}>
                                  Subscription Features :{' '}
                                </Typography> */}
                          <Typography variant="body2" sx={{ marginTop: '4px' }}>
                            <ul>
                              {subscriptionPlan?.activeSubscription?.plan?.features &&
                                Array.isArray(subscriptionPlan?.activeSubscription?.plan?.features) &&
                                subscriptionPlan?.activeSubscription?.plan?.features?.map((f, index) => {
                                  return <li key={index}>{f}</li>;
                                })}
                            </ul>
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  {/* Action Buttons */}
                  <Stack direction="column" justifyContent="right" spacing={2} sx={{ marginTop: '0px', padding: '0 15px 16px 15px' }}>
                    {/* <Button disableElevation variant="contained" sx={{ color: '#fff' }} startIcon={<AddIcon />}>
                              Add Subscription
                            </Button> */}
                    {subscriptionPlan?.activeSubscription?.subscription?.status === 'APPROVAL_PENDING' ? (
                      <>
                        {/* <p>{machineSubscriptionleftTimeText}</p> */}
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'right' }}>
                          <span
                            style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              justifyItems: 'flex-end'
                            }}
                          >
                            <Button
                              disableElevation
                              variant="contained"
                              sx={{
                                color: '#fff',
                                backgroundColor: '#448864',
                                width: '150px'
                                /*'&:hover': {
                              backgroundColor: '#FFB74D' // Adjust this color as needed for hover effect
                            }*/
                              }}
                              startIcon={<OpenInNewIcon />}
                              onClick={() => {
                                window.open(subscriptionPlan?.activeSubscription?.subscription?.paymentLink, '_blank', 'noopener');
                              }}
                            >
                              Payment Link
                            </Button>
                            <Typography variant="body2" display={'flex'} sx={{ marginTop: '4px', paddingTop: '8px' }}>
                              <AnimatedTimer /> {machineSubscriptionleftTimeText}
                            </Typography>
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <Grid item xs={12}>
                          <Stack direction="row" justifyContent={'right'} spacing={2} sx={{ p: 2 }}>
                            <Button
                              disableElevation
                              variant="contained"
                              sx={{ color: '#fff' }}
                              startIcon={<AutorenewIcon />}
                              onClick={() => {
                                navigate('/dashboard/machines/subcription-view', {
                                  state: {
                                    machineId: open.machineId,
                                    type: 'change',
                                    subId: subscriptionPlan?.activeSubscription?.plan?.id
                                  }
                                });
                              }}
                            >
                              Change Subscription
                            </Button>
                          </Stack>
                        </Grid>
                      </>
                    )}

                    {/* <Button
                            disableElevation
                            className="machineViewBtn1"
                            variant="outlined"
                            sx={{ width: 'unset', flexGrow: 'unset' }}
                            color="error"
                          >
                            Cancel Subscription
                          </Button> */}
                  </Stack>
                </div>
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
                <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
                  <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
                    Machine Subscription
                  </Typography>
                </div>
                <Stack direction="column" alignItems="center" spacing={2} sx={{ p: 3 }}>
                  <Typography variant="h5">You currently have no subscription. Click the button below to add one.</Typography>
                  <Button
                    disableElevation
                    variant="contained"
                    sx={{ color: '#fff' }}
                    startIcon={<AddIcon />}
                    onClick={() => {
                      if (!callFrom) {
                        navigate('/dashboard/machines/subcription-view', {
                          state: { machineId: open.machineId, type: 'add', subId: null }
                        });
                      } else if (callFrom && callFrom === 'Employee') {
                        const machineSubFromEmployee = {
                          passedObject: { machineId: open.machineId, type: 'add', subId: null },
                          callFrom: callFrom,
                          setOpenViewModal: setOpen,
                          openViewModal: open
                        };
                        setOpen((state) => ({
                          ...state,
                          open: false,
                          openSubscription: true,
                          machineSubFromEmployee: machineSubFromEmployee
                        }));
                      }
                    }}
                  >
                    Add Subscription
                  </Button>
                </Stack>
              </div>
            </Grid>
          )}
        </>
      )}
    </>
  );
}
